import React from 'react';
import { Container, Box } from '@mui/material';

const SectionContainer = ({ 
  children, 
  maxWidth = 'lg', 
  sx = {}, 
  backgroundColor = 'transparent',
  py = 8 
}) => {
  return (
    <Box
      sx={{
        backgroundColor,
        py,
        ...sx,
      }}
    >
      <Container maxWidth={maxWidth}>
        {children}
      </Container>
    </Box>
  );
};

export default SectionContainer;